import { render, staticRenderFns } from "./Paris.vue?vue&type=template&id=5b05d5bc&"
import script from "./Paris.vue?vue&type=script&lang=js&"
export * from "./Paris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports